import React, {forwardRef} from 'react'
import * as TablerData from '@tabler/icons-react'
import {TablerIconsProps} from '@tabler/icons-react'
import {CustomIcons, customIcons} from './custom-icons-16'

// eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
const {createReactComponent, ...Icons} = TablerData

export const AllIcons = Icons

export type TablerIcons = keyof typeof AllIcons | CustomIcons

const tablerIcons = Icons as {
  [key in TablerIcons]: (props: TablerIconsProps) => React.ReactElement
}

export type IconType = 'sticker' | 'ui' | 'navigation' | 'main-menu'

export interface IconTablerProps {
  type?: IconType
  icon: TablerIcons
  viewBox?: string
  customSize?: number
  className?: string
  onClick?: (e: React.MouseEvent) => void
  style?: React.CSSProperties
}

interface TypeParams {
  size: number
  stroke: number
}

const getTypeParams = (type: IconType): TypeParams => {
  switch (type) {
    case 'sticker': {
      return {
        size: 14,
        stroke: 1.35
      }
    }
    case 'ui': {
      return {
        size: 16,
        stroke: 2
      }
    }
    case 'navigation': {
      return {
        size: 20,
        stroke: 1.4
      }
    }
    case 'main-menu': {
      return {
        size: 20,
        stroke: 1.3
      }
    }
  }
}

export const IconTabler = forwardRef<SVGSVGElement, IconTablerProps>(
  (props, forwardedRef) => {
    const {type = 'ui', icon, viewBox, customSize, className, onClick} = props
    const {style} = props
    const {size, stroke} = getTypeParams(type)

    if (tablerIcons[icon]) {
      return React.createElement(tablerIcons[icon], {
        size: customSize ?? size,
        style,
        type,
        stroke,
        viewBox,
        className,
        onClick,
        ref: forwardedRef
      })
    }

    const CustomIcon = customIcons[icon as CustomIcons]
    if (CustomIcon) {
      return (
        <CustomIcon
          style={style}
          ref={forwardedRef}
          className={className}
          onClick={onClick}
        />
      )
    }

    throw new Error(`Icon not found ${icon}`)
  }
)
